<template>
  <div class="container-fluid">
    <!-- Nav tabs -->
    <ul class="nav nav-tabs customtab" role="tablist">
      <li class="nav-item">
        <a
          class="nav-link active"
          data-toggle="tab"
          href="#capacitacionPlaneada"
          role="tab"
          ><span class="hidden-xs-down">
            {{ $t("page.content_dashboard.tabs.capacitacion_pendiente") }}
          </span></a
        >
      </li>
      <li v-if="cia.enable_bloques_cursos === '1'" class="nav-item">
        <a
          class="nav-link"
          data-toggle="tab"
          href="#capacitacionBloques"
          role="tab"
          ><span class="hidden-xs-down">
            {{ $t("page.content_dashboard.tabs.capacitacion_bloques") }}
          </span></a
        >
      </li>
      <li class="nav-item">
        <a class="nav-link" data-toggle="tab" href="#constancias" role="tab"
          ><span class="hidden-xs-down">
            {{ $t("page.content_dashboard.tabs.mis_constancias") }}
          </span></a
        >
      </li>
    </ul>
    <!-- Tab panes -->
    <div class="tab-content">
      <div class="tab-pane active" id="capacitacionPlaneada" role="tabpanel">
        <div class="container listContent">
          <div class="card">
            <b-table
              responsive
              sticky-header="300px"
              striped
              hover
              :fields="fields"
              :items="items"
            >
            <template #head(nombre)="data">
              <span>{{ $t("page.general.curso") }}</span>
            </template>
            <template #head(acciones)="data">
              <span>{{ $t("page.general.acciones") }}</span>
            </template>

              <template #cell(nombre)="data">
                <div class="row align-items-center">
                  <div class="col-auto imgRow">
                    <img
                      :src="data.item.nombre.img"
                      alt="imgCurso"
                      width="70"
                      @error="data.item.nombre.img = '/static/img/temas/ejemplo_tema_1.jpg'"
                    />
                  </div>
                  <div class="col-8">
                    <div class="container">
                      <div class="row textNameRow">
                        {{ data.item.nombre.text }}
                      </div>
                      <div class="row">
                        <span
                          class="
                            badge badge-pill badge-danger
                            right
                            badgeScore
                          "
                          v-if="data.item.acciones.requerimiento.obligatoria == '1'"
                        >
                          {{ $t("page.general.obligatorio") }}
                        </span>
                        <span
                          class="
                            badge badge-pill badge-success
                            right
                            badgeScore
                            badgeOpcional
                          "
                          v-else
                        >
                          {{ $t("page.general.opcional") }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(acciones)="data">
                <div @click="setReq(data.item.acciones.requerimiento)">
                  <actions
                    @EstudiarScorm="
                      Estudiar_Scorm(data.item.acciones.requerimiento)
                    "
                    @VerMaterial="
                      Ver_Material(data.item.acciones.requerimiento)
                    "
                    @PresentarExamen="
                      Presentar_Examen(data.item.acciones.requerimiento)
                    "
                    :requerimiento="data.item.acciones.requerimiento"
                  />
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="tab-pane" id="capacitacionBloques" role="tabpanel">
        <div class="container listContent">
          <div class="card">

            <div
              class="b-table-sticky-header table-responsive"
              style="max-height: 300px;"
              v-if="this.itemsBloques.length === 0"
            >
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th scope="col">{{ $t("page.constancia.nombre_curso") }}</th>
                    <th scope="col">{{ $t("page.constancia.tipo_bloque") }}</th>
                    <th scope="col">{{ $t("page.constancia.documento") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colspan="3" class="text-center" >
                      <h6 class="mr-4">Sin bloques</h6>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <b-table
              responsive
              sticky-header="300px"
              striped
              hover
              :fields="fieldsBloques"
              :items="itemsBloques"
              v-else="this.itemsBloques.length > 0"
            >

              <template #head(nombreBloque)="data">
                <span>{{ $t("page.general.bloque") }}</span>
              </template>

              <template #head(tipo)="data">
                <span>{{ $t("page.general.tipo") }}</span>
              </template>

              <template #head(accionesBloque)="data">
                <span>{{ $t("page.general.avance") }}</span>
              </template>

              <template #cell(nombreBloque)="data">
                <div class="row align-items-center">
                  <div class="col-8">
                    <div class="container">
                      <div class="row textNameRow">
                        {{ data.item.nombre_bloque }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(tipo)="data">
                <div class="row align-items-center">
                  <div class="col-8">
                    <div class="container">
                      <div class="row textNameRow">
                        {{ data.item.tipo_bloque }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(accionesBloque)="data">
                <div class="row textNameRow" style="align-items: center;justify-content: end;">
                  <div class="column mr-3">
                      <h4>{{data.item.porcentaje_avance}}%</h4>

                      <div class="progress">
                        <div
                          class="progress-bar"
                          role="progressbar"
                          :style="{ 'width': data.item.porcentaje_avance + '%'}"
                          aria-valuenow="25"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                  </div>

                  <div class="col container botButtons" align="center">
                    <div class="row">
                      <div class="col-auto">
                        <button
                          type="button"
                          class="custom-btn waves-effect waves-light btn-info"
                          data-trigger="hover"
                          data-placement="bottom"
                          data-container="body"
                          data-toggle="popover"
                          title="Temas"
                          :id="data.item.id_bloque"
                          href=""
                          @click="abrirModalTemas(data.item)"
                        >
                          <i class="fas fa-file-alt"></i>
                        </button>
                      </div>
                    </div>
                    <div
                      class="row textUnder"
                    >
                      {{ $t("page.general.temas") }}
                    </div>
                  </div>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="tab-pane p-20" id="constancias" role="tabpanel">
        <misconstancias setTitle="true" :bloques="itemsBloques" />
      </div>
    </div>
    <div
      class="modal fade"
      id="modal_curso_plan_capacitacion_material"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal_curso_plan_capacitacion_materialLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog full_modal-dialog" role="document">
        <div class="modal-content full_modal-content">
          <div class="modal-header text-center pb-2 pt-2">
            <h5 class="mb-0 pt-2">Material</h5>
            <button
              v-on:click="Material_Completado"
              v-if="requerimiento.estatus_material != 'Material_Completado'"
              class="btn ml-3 btn-success btn-sm"
            >
              Completado
              <i
                v-if="cargando_material_completado"
                class="fas fa-spinner fa-spin"
              ></i>
            </button>
            <button
              type="button"
              v-on:click="resetear_vista"
              id="cerrar_modal_material"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" id="modal_body_iframe">
            <div v-bind:class="loading_modal_material">
              <div class="d-flex justify-content-center">
                <div class="spinner-border m-5" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
            <div
              class="text-center"
              v-bind:class="result_modal_material"
              id="iframe_curso"
            >
              Abriendo Link del Material...
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div
      class="modal fade"
      id="modal_curso_plan_capacitacion2"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal_curso_plan_capacitacion2Label"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div
            class="modal-header bg_blue text-white"
            v-bind:class="{ 'bg_primary text-white': presentar_examen }"
          >
            <h5
              class="modal-title"
              v-if="presentar_examen"
              id="modal_curso_plan_capacitacion2Label"
            >
              Presentar Examen - {{ requerimiento.nombre }}
            </h5>
            <button
              type="button"
              id="cerrar_modal2"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-bind:class="loading_modal2">
              <div class="d-flex justify-content-center">
                <div class="spinner-border m-5" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
            <div :class="result_modal2">
              <presentarexamen
                @ActualizarExamen="ActualizarExamen"
                v-if="presentar_examen"
                v-bind:preguntas="preguntas_examen"
              ></presentarexamen>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger"
              v-on:click="Cerrar_Modal2"
            >
              Cerrar
            </button>
            <button
              type="button"
              class="btn btn-success"
              v-if="presentar_examen"
              v-on:click="Guardar_Examen_Presentado"
            >
              Enviar Respuestas
            </button>
          </div>
        </div>
      </div>
    </div> -->


    <div
      class="modal fade"
      id="modal_curso_plan_capacitacion2"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal_curso_plan_capacitacion2Label"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header headerMulti justify-content-start">
            <h5
              class="modal-title headerTitle"
              v-if="calificar_curso"
              id="modal_curso_plan_capacitacion2Label"
            >
              {{ $t("page.consulta_plan_capacitacion.evaluacion_salida") }}
            </h5>
            <h5
              class="modal-title headerTitle text-start"
              v-if="presentar_examen"
              id="modal_curso_plan_capacitacion2Label"
            >
              Examen - {{ requerimiento.nombre }}
            </h5>
            <button
              type="button"
              id="cerrar_modal2"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >

              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" :style="modalStyle">
            <div v-bind:class="loading_modal2">
              <div class="d-flex justify-content-center">
                <div class="spinner-border m-5" role="status">
                  <span class="sr-only">{{ $t("page.general.cargar") }}</span>
                </div>
              </div>
            </div>
            <div :class="result_modal2">
              <calificarcurso
                @ActualizarEvaluacion="ActualizarEvaluacion"
                v-bind:evaluacion="evaluar_curso"
                v-if="calificar_curso"
              ></calificarcurso>
              <presentarexamen
                @inicio="
                  () => {
                    this.resultados = {};
                  }
                "
                @ActualizarExamen="ActualizarExamen"
                v-if="presentar_examen"
                v-bind:preguntas="preguntas_examen"
                :detalle="detalle"
                @terminar_examen="Guardar_Examen_Presentado"
                :nombre="requerimiento.nombre"
                :resultados="resultados"

              />
            </div>
          </div>
          <div class="modal-footer" v-if="!presentar_examen">
            <button
              type="button"
              class="btn btn-danger"
              v-if="calificar_curso"
              v-on:click="Cerrar_Modal2"
            >
              {{ $t("page.consulta_plan_capacitacion.cerrar") }}
            </button>
            <button
              type="button"
              class="btn btn-success"
              v-if="calificar_curso"
              v-on:click="Guardar_Evaluacion_Curso"
            >
              {{ $t("page.consulta_plan_capacitacion.evaluar_curso") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modal_temas"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal_temasLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header text-center pb-2 pt-2">
            <h5 class="mb-0 pt-2">Temas del bloque: {{ bloqueSeleccionado.nombre_bloque }}</h5>
            <button
              type="button"
              v-on:click="resetear_vista"
              id="cerrar_modal_material"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" id="modal_body_temas">
            <div v-for="(tema, index) in bloqueSeleccionado.temas" class="mt-2 temas-container">
              <span class="progress-label" style="width: 60%;">{{tema.nombre}}</span>
              <div class="progress-container">
                <div class="progress">
                  <div
                    class="progress-bar"
                    role="progressbar"
                    style="width: 100%;"
                    :style="{
                      'background-color': tema.acreditado == '1' ? '#28a745' : 'gray'
                    }"
                    aria-valuenow="25"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    {{tema.acreditado == '1' ? 'Acreditado' : 'Pendiente'}}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger"
              v-on:click="cerrarModalTemas"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { storage, firestore } from "@/firebase.js";
import actions from "./actionsCol.vue";
import { mapActions } from "vuex";
import MisConstancias from "../../MisConstancias/MisConstancias.vue";
import Presentar_Examen from "../../../Plan_Capacitacion/Consultar_Plan_Capacitacion/acciones/presentar_examen.vue";
export default {
  data() {
    return {
      fields: [
        { label: "Cursos", key: "nombre", thClass: "nombreCol" },
        { label: "Acciones", key: "acciones", thClass: "accionesCol" }
      ],
      items: [],
      fieldsBloques: [
        { label: "Bloque", key: "nombreBloque", thClass: "nombreCol" },
        { label: "Tipo", key: "tipo", thClass: "tipoCol" },
        { label: "Avance", key: "accionesBloque", thClass: "accionesCol" }
      ],
      itemsBloques: [],
      consultar_cursos: "Pendientes",
      loading_modal_material: "",
      result_modal_material: "",
      requerimiento: {},
      cargando_material_completado: false,
      loading_modal2: "",
      result_modal2: "",
      preguntas_examen: [],
      presentar_examen: false,
      bloqueSeleccionado: {},
    };
  },
  methods: {
    Consultar_Planeada_Bloques_Empleado() {
      this.$http
        .post(
          "plan_capacitacion/consultar_plan_capacitacion/planeada/por-bloques/" +
            this.usuario.cve_empleado +
            "/dat",
          {
            buscar: "",
          }
        )
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          // this.itemsBloques = respuestaJson;
          const items = [];
          respuestaJson.forEach(tipoBloque => {
            tipoBloque.bloques.forEach(bloque => {
              this.itemsBloques.push(bloque);
            });
          });
        })
        .catch((error) => {
          toastr.clear();
          toastr.error(this.$t('page.historial_capacitacion.js_scope.prob_historial'));
          // this.Listo_Modal();
        });
    },
    Cargando_Modal_Material() {
      this.loading_modal_material = "";
      this.result_modal_material = "d-none";
    },
    Ver_Material(requerimiento) {
      var that = this;
      this.AbrirCurso();
      this.Cargando_Modal_Material();
      $(document).ready(function() {
        setTimeout(async function() {
          var height_modal =
            Number(
              $("#modal_body_iframe")
                .css("height")
                .replace("px", "")
            ) - 20;
          var width_modal =
            Number(
              $("#modal_body_iframe")
                .css("width")
                .replace("px", "")
            ) - 30;
          switch (that.requerimiento.tipo_manual_participante) {
            case "youtube":
              requerimiento.manual_participante = requerimiento.manual_participante.replace(
                "https://www.youtube.com/watch?v=",
                ""
              );
              requerimiento.manual_participante = requerimiento.manual_participante.replace(
                "http://www.youtube.com/watch?v=",
                ""
              );
              requerimiento.manual_participante = requerimiento.manual_participante.replace(
                "//www.youtube.com/watch?v=",
                ""
              );
              requerimiento.manual_participante = requerimiento.manual_participante.replace(
                "//youtube.com/watch?v=",
                ""
              );
              requerimiento.manual_participante = requerimiento.manual_participante.replace(
                "www.youtube.com/watch?v=",
                ""
              );
              requerimiento.manual_participante = requerimiento.manual_participante.replace(
                "youtube.com/watch?v=",
                ""
              );
              var buscar_time = requerimiento.manual_participante.search("&t=");
              if (buscar_time > 0) {
                requerimiento.manual_participante = requerimiento.manual_participante.substr(
                  0,
                  buscar_time
                );
              }
              var iframe = $(
                '<iframe width="' +
                  width_modal +
                  '" height="' +
                  height_modal +
                  '" src="https://www.youtube.com/embed/' +
                  requerimiento.manual_participante +
                  '"></iframe>'
              );
              break;
            case "image/*":
              var iframe = $(
                '<img style="max-height:500px;width:auto;" src="' +
                  requerimiento.manual_participante +
                  '"></img>'
              );
              break;
            case "video/mp4,video/x-m4v,video/*":
              var iframe = $(
                '<video id="videoVer" width="' +
                  width_modal +
                  '" height="' +
                  height_modal +
                  '" controls controlsList="nodownload"><source src="' +
                  requerimiento.manual_participante +
                  '">Your browser does not support the video tag.</video>'
              );
              $(document).ready(() => {
                document
                  .getElementById("videoVer")
                  .addEventListener("contextmenu", event =>
                    event.preventDefault()
                  );
              });
              break;
            case ".pdf":
              let pdf = await that.construirPDF(requerimiento);
              var iframe = $(pdf);
              break;
            default:
              var iframe = $(
                '<h3 class="mt-5">Link Abierto en otra página</h3>'
              );
              window.open(
                (requerimiento.manual_participante == '' || !requerimiento.manual_participante)
                  ? requerimiento.meeting
                  : requerimiento.manual_participante,
                "Manual Participante"
              );
              break;
          }
          that.Listo_Modal_Material();
          $("#iframe_curso")
            .empty()
            .append(iframe);
        }, 2000);
      });
    },
    async construirPDF(requerimiento) {
      return `<div id="mypdf" style="width: 100%;">
<iframe src="${requerimiento.manual_participante}#zoom=150&toolbar=0" style="width: 100%; height: 80vh;" frameborder="0" scrolling="no" id="frameNOPROPAGE">
        <p>Your web browser doesn't support iframes.</p>
   </iframe>
</div>`;
    },
    Guardar_Examen_Presentado() {
      this.Cargando_Modal2();
      this.$http
        .post(
          "plan_capacitacion/consultar_plan_capacitacion/planeada/" +
            this.usuario.cve_empleado +
            "/presentar_examen/" +
            this.requerimiento.cve_curso,
          {
            preguntas: this.preguntas_examen
          }
        )
        .then(respuesta => {
          return respuesta.json();
        })
        .then(respuestaJson => {
          if (respuestaJson.resp == "Excelente") {
            this.Listo_Modal2();
            this.Cerrar_Modal2();
            this.loadAll();
            // let k = JSON.parse(JSON.parse(respuestaJson.reponse_ternium).body);
            if (respuestaJson.acreditado == "no acreditado") {
              swal(
                `No acreditaste tu examen, te quedan ${respuestaJson.int_rest} intentos`,
                `Calificacion: ${respuestaJson.calificacion}`,
                "error"
              );
            } else {
              swal(
                "Felicidades, aprobaste tu examen",
                `Calificacion: ${respuestaJson.calificacion}`,
                "success"
              );
            }
          } else {
            this.Listo_Modal2();
            swal("¡Ups!", respuestaJson.resp, "error");
          }
        })
        .catch(error => {
          console.log('DEBUG: error', error);
          this.Listo_Modal2();
          swal("¡Ups!", "Problemas para grabar el examen", "error");
        });
    },
    ActualizarExamen(datos) {
      this.preguntas_examen = datos;
    },
    Cargando_Modal2() {
      this.loading_modal2 = "";
      this.result_modal2 = "d-none";
    },
    Cerrar_Modal2() {
      $("#modal_curso_plan_capacitacion2").modal("hide");
    },
    Abrir_Modal2() {
      $("#modal_curso_plan_capacitacion2").modal("show");
    },
    cerrarModalTemas() {
      $("#modal_temas").modal("hide");
    },
    abrirModalTemas(bloque) {
      this.bloqueSeleccionado = bloque
      $("#modal_temas").modal("show");
    },
    Listo_Modal2() {
      this.loading_modal2 = "d-none";
      this.result_modal2 = "";
    },
    Presentar_Examen(requerimiento) {
      this.Cargando_Modal2();
      this.Abrir_Modal2();
      this.$http
        .get(
          "plan_capacitacion/consultar_plan_capacitacion/planeada/" +
            this.usuario.cve_empleado +
            "/presentar_examen/" +
            requerimiento.cve_curso
        )
        .then(respuesta => {
          return respuesta.json();
        })
        .then(respuestaJson => {
          this.preguntas_examen = respuestaJson.preguntas;
          this.detalle = respuestaJson.detalle;
          this.presentar_examen = true;
          this.Listo_Modal2();
        })
        .catch(error => {
          this.Listo_Modal2();
          this.Cerrar_Modal2();
          swal("¡Ups!", "Problemas para traer la evaluación", "error");
        });
    },

    Material_Completado() {
      this.cargando_material_completado = true;
      toastr.clear();
      this.$http
        .put(
          "mobile/temas/material/completado/" +
            this.requerimiento.cve_inscripcion_ai
        )
        .then(respuesta => {
          return respuesta.json();
        })
        .then(respuestaJson => {
          if (respuestaJson.resp == "Excelente") {
            this.requerimiento.estatus_material = "Material_Completado";
            toastr.success("Material Completado");
          } else {
            toastr.error(respuestaJson.resp);
          }
        })
        .catch(error => {
          toastr.error(
            "Problemas para consultar el curso",
            "Favor de internet mas tarde"
          );
        })
        .finally(response => {
          this.cargando_material_completado = false;
        });
    },
    setReq(el) {
      this.requerimiento = el;
    },
    async resetear_vista() {
      let that = this;
      if (this.requerimiento.clave_scorm) {
        await this.$http
          .get(
            this.$http.options.root +
              "/cursos/puntaje_usuario/" +
              this.usuario.cve_empleado +
              "/" +
              this.requerimiento.clave_scorm
          )
          .then(async res => {
            console.log(res.body);
            if (res.body.status == "passed" || res.body.status == "failed") {
              var formdata = new FormData();
              formdata.append("nombre_usuario", this.usuario.cve_empleado);
              formdata.append("cve_tema", this.requerimiento.cve_tema);
              formdata.append("calificacion", res.body.score);
              formdata.append("status", res.body.status);
              this.setValuesRequerimiento({
                cve_tema: that.requerimiento.cve_tema,
                calif: res.body.score,
                status: res.body.status,
                requerimientos: [that.requerimiento]
              });
              //await this.$http.post("cursos/setPuntajeTema", formdata);
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
      this.requerimiento = {
        cve_tema: null,
        tema_institucional: "",
        horas: "",
        area_manager: "",
        pais: "",
        planta: "",
        linea: "",
        carrera: "",
        especialidad: "",
        cve_curso: null
      };
      $("#iframe_curso").empty();
    },
    Estudiar_Scorm(requerimiento) {
      this.AbrirCurso();
      let that = this;
      var iframe;
      let newURL;
      if (requerimiento.link.includes("qualtia")) {
        newURL =
          requerimiento.link.split("/v3")[0] +
          requerimiento.link.split("/v3")[1];
      } else {
        newURL = requerimiento.link;
      }
      let url;
      if (newURL.split("undefined")[0] != undefined) {
        url = newURL.split("undefined")[0];
      } else {
        url = newURL;
      }
      iframe = $(
        '<form id="loginForm" target="myFrame"  action="' +
          url +
          '" method="POST">' +
          '<input type="text" name="login" value="' +
          that.usuario.cve_empleado +
          '" />' +
          '<input type="text" name="password" value="' +
          that.usuario.cve_empleado +
          '" />' +
          '<input type="text" name="submitAuth" value="" />' +
          '<input type="text" name="_qf__formLogin" value="" />' +
          '<input type="submit">' +
          "</form>" +
          '<iframe id="iframeScorm" name="myFrame" src="#" style="width:100%; height:45em;">' +
          "Your browser does not support inline frames." +
          "</iframe>"
      );
      $(document).ready(function() {
        $("#iframe_curso")
          .empty()
          .append(iframe);
        var loginform = document.getElementById("loginForm");
        loginform.style.display = "none";
        var loginframe = document.getElementById("iframeScorm");
        loginframe.style.display = "none";
        loginform.submit();
      });
      setTimeout(() => {
        $(document).ready(function() {
          iframe = $(
            '<iframe name="myFrame" src="' +
              url +
              '" style="width:100%; height:45em;">' +
              "   Your browser does not support inline frames." +
              "</iframe>"
          );
          $("#iframe_curso")
            .empty()
            .append(iframe);
          that.Listo_Modal_Material();
        });
      }, 3000);
    },
    Listo_Modal_Material() {
      var that = this;
      $(document).ready(function() {
        that.loading_modal_material = "d-none";
        that.result_modal_material = "";
      });
    },
    AbrirCurso() {
      $("#modal_curso_plan_capacitacion_material").modal("show");
    },
    loadAll() {
      this.$http
        .post(
          "plan_capacitacion/consultar_plan_capacitacion/planeada/" +
            this.usuario.cve_empleado +
            "/" +
            this.consultar_cursos,
          {
            buscar: ""
          }
        )
        .then(respuesta => {
          let array = [];
          respuesta.body.map(el => {
            el.temas.map(realEl => {
              if (realEl.cve_inscripcion_ai) {
                array.push({
                  nombre: { text: realEl.nombre, img: realEl.link_img },
                  acciones: { requerimiento: realEl }
                });
              }
            });
          });
          this.items = array;
          $('[data-toggle="popover"]').popover();
        });
    },
    ...mapActions(["setValuesRequerimiento"])
  },
  components: {
    actions,
    presentarexamen: Presentar_Examen,
    misconstancias: MisConstancias
  },
  created() {
    this.loadAll();
    this.Consultar_Planeada_Bloques_Empleado();
  },
  computed: {
    usuario() {
      return this.$store.getters.getUsuario;
    },
    cia() {
      return this.$store.getters.getCia;
    }
  },

  mounted() {
    let that = this;
    $('[data-toggle="popover"]').popover();
    $("#modal_curso_plan_capacitacion_material").on(
      "hidden.bs.modal",
      function() {
        console.log("has been closed");
        that.loadAll();
        that.resetear_vista();
      }
    );
  }
};
</script>

<style scoped>
.customtab {
  font-size: 1.2em;
  font-weight: 500;
}

.nav-tabs .nav-link {
  color: rgba(95, 96, 97, 0.986) !important;
}
.nav-tabs .nav-link:hover {
  color: rgb(33, 37, 41) !important;
  background-color: rgba(149, 149, 149, 0.267);
}
.nav-tabs .nav-link.active {
  color: rgb(33, 37, 41) !important;
  background-color: rgba(128, 128, 128, 0.103);
}

.nav-tabs .nav-link.active:hover {
  background-color: rgba(149, 149, 149, 0);
}

.listContent {
  padding: 0;
}
.imgRow,
.textNameRow {
  padding: 0;
  font-size: 1.1em;
}

.imgRow {
  padding-left: 0.5em;
  padding-right: 0.5em;
}

.table /deep/ td {
  padding-top: 0.4em !important;
  padding-bottom: 0.4em !important;
}

/deep/ .nombreCol,
/deep/ .tipoCol,
/deep/ .accionesCol {
  text-align: center;
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: white;
}

/deep/ .accionesCol {
  width: 18em;
}

::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(128, 128, 128, 0.315);
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(128, 128, 128, 0.363);
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: grey;
}

.badgeOpcional {
  background-color: #848484 !important;
}

.progress {
  flex: 1; /* Hace que la barra de progreso ocupe el espacio restante */
  height: 10px; /* Ajusta la altura de la barra de progreso */
  border-radius: 30px;
  border: 1px solid gray;
  width: 100%;
}

.progress-bar {
  line-height: 10px; /* Alinea el texto verticalmente dentro de la barra */
  background-color: #28a745;
  text-transform: none;
}

.column {
  display: flex;
  flex-direction: column; /* Coloca los elementos verticalmente */
  align-items: center; /* Alinea los elementos al inicio del contenedor */
  width: 50%;
  height: 40px
}

.botButtons {
  padding: 0;
  margin: -0.5px;
}

.botButtons button {
  color: grey;
  background-color: rgba(148, 148, 148, 0.308);
  border: none;
  max-width: 3em;
  width: 40px;
}
.textUnder {
  font-size: 0.8em;
  text-align: center;
  font-weight: 500;
}

button:disabled {
  cursor: default;
  background-color: rgba(201, 198, 198, 0.356);
  color: rgba(201, 198, 198, 0.685);
}
.textUnder.true {
  color: rgba(201, 198, 198, 0.685);
}

.botButtons > .row {
  width: min-content;
}
.custom-btn {
  font-size: 1.5em;
  padding: 0;
}

.progress-container {
  width: 40%;
}

.temas-container {
  display: flex;
  justify-content: space-between;
}

.progress-label {
  font-weight: bold;
  margin-right: 10px; /* Ajusta el espacio entre la etiqueta y la barra de progreso */
}

.progress {
  flex: 1; /* Hace que la barra de progreso ocupe el espacio restante */
  height: 20px; /* Ajusta la altura de la barra de progreso */
  border-radius: 30px;
  border: 1px solid gray;
  width: 100%;
}

.progress-bar {
  line-height: 20px; /* Alinea el texto verticalmente dentro de la barra */
  background-color: #28a745;
  text-transform: none;
}
.text-center {
  text-align: center;
}

#modal_curso_plan_capacitacion2 .modal-dialog.modal-xl {
  margin-top: 0;
  max-width: 95vw !important;
}
</style>



// WEBPACK FOOTER //
// src/components/AppLms/Dashboard/Vistas_Por_Perfil/Tabs/tabsDashboard.vue